import { render, staticRenderFns } from "./tipositem-form.vue?vue&type=template&id=54c2e6cd&scoped=true"
import script from "./tipositem-form.vue?vue&type=script&lang=js"
export * from "./tipositem-form.vue?vue&type=script&lang=js"
import style0 from "./tipositem-form.vue?vue&type=style&index=0&id=54c2e6cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c2e6cd",
  null
  
)

export default component.exports